// TSS vite/05 — session helpers.
//
// With the cookie+CSRF transport, the session JWT lives in an httpOnly
// cookie that JS cannot read. The only JS-readable tokens are the session
// CSRF cookie (echoed by the api interceptor on every mutating request) and
// csrf_token_register (the pre-session CSRF bootstrap of the invite flow,
// set by GET public/register/:token and echoed explicitly by that page).
//
// Cookie namespacing ([0073] / Q-197): the client channel uses its OWN cookies
// `client_auth_token` (httpOnly) + `client_csrf_token` (readable), isolated
// from the staff channel's `auth_token`/`csrf_token`. Browsers scope cookies by
// (domain, path) — NOT by port — so without distinct names the staff dashboard
// and the client portal on the same host would clobber each other's session.
// The register bootstrap keeps `csrf_token_register` (no collision).
//
// Cookies are set by the backend on public/auth/login (and /register/:token)
// and cleared on public/auth/logout (and on the register POST success).

import { STORAGE_KEYS } from '../constants/storage';

const CSRF_COOKIE = 'client_csrf_token';
const REGISTER_CSRF_COOKIE = 'csrf_token_register';

function readCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
}

export function readCsrfCookie() {
    return readCookie(CSRF_COOKIE);
}

export function readRegisterCsrfCookie() {
    return readCookie(REGISTER_CSRF_COOKIE);
}

// Forces every other tab to log out. The interceptor (or AuthProvider)
// flips this key when it detects a 401 or after a /auth/logout call.
// Per TSS vite/05 §"Logout-everywhere and session invalidation".
export function broadcastLogout() {
    try {
        localStorage.setItem(STORAGE_KEYS.LOGOUT_SIGNAL, String(Date.now()));
    } catch {
        // localStorage may be unavailable (private mode, quota); ignore.
    }
}
